import React, { Component } from 'react';
import { View, ScrollView, TouchableWithoutFeedback } from 'react-native';

import { isEmpty as _isEmpty, get as _get } from 'lodash';
import PropTypes from 'prop-types';

import { Icon, VFButton, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import Accordion from '@vfgroup-oneplatform/foundation/Components/Timeline/Accordion/Accordion';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import FrameWorkImages from '../../../Themes/Images';

import DeviceUpgradeCollection from './Component/DeviceUpgradeCollection';
import DeviceUpgradeSections from './Component/DeviceUpgradeSections';
import { SECTIONS } from './Component/DeviceUpgradeSections/DeviceUpgradeSections';
import DeviceUpgradeSpecification from './Component/DeviceUpgradeSpecification';
import styles from './DeviceDetails.Styles';

class DeviceDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeSections: [],
    };
  }
  componentDidUpdate(prevProps) {
    const {
      deviceDetails,
      selectColorTypeOption,
      selectCapacityTypeOption,
      isEditMode,
      selectedColorIndex,
      selectedCapacityIndex,
    } = this.props;
    if (prevProps.isDeviceDetailLoading && this.props.isDeviceDetailLoading === false) {
      if (deviceDetails?.capacity?.length) {
        selectCapacityTypeOption(isEditMode ? selectedCapacityIndex : 0);
      }
      if (deviceDetails?.colors?.length) {
        selectColorTypeOption(isEditMode ? selectedColorIndex : 0);
      }
    }
  }
  selectOption = (index, section) => {
    const { selectCapacityTypeOption, selectColorTypeOption } = this.props;
    if (section === SECTIONS.CAPACITY_TYPE) {
      selectCapacityTypeOption(index);
    } else {
      selectColorTypeOption(index);
    }
  };

  renderSeparator = () => {
    return (
      <View style={styles.separatorContainer}>
        <View style={styles.separatorContent(this.props.theme)} />
      </View>
    );
  };
  renderMoreInfo = () => {
    const { deviceDetails, onDeviceFullSpecsPress, theme } = this.props;
    const { activeSections } = this.state;
    const list = [
      {
        icon: (
          <Icon
            name={FrameWorkImages.ic_list}
            type="image"
            size={33}
            style={styles.listIcon(theme)}
          />
        ),
        text: 'device_upgrade_device_step_specifications',
        content: (
          <DeviceUpgradeSpecification
            specifications={deviceDetails?.specifications ?? []}
            boxContent={deviceDetails?.boxContent ?? []}
            fullSpecifications={deviceDetails?.fullSpecifications ?? []}
            onDeviceFullSpecsPress={onDeviceFullSpecsPress}
          />
        ),
      },
      {
        icon: (
          <Icon
            name={FrameWorkImages.ic_store}
            type="image"
            size={32}
            style={styles.listIcon(theme)}
          />
        ),
        text: 'device_upgrade_device_step_collection_and_delivery',
        content: <DeviceUpgradeCollection collection={deviceDetails.collection} />,
      },
    ];
    return (
      <Accordion
        activeSections={activeSections}
        underlayColor={null}
        sections={list.map(item => item.text)}
        touchableProps={{ testID: FrameworkTestKeys.AccordionDeviceSectionHeader }}
        renderHeader={(content, index) => {
          const icon = activeSections.includes(index)
            ? FrameWorkImages.icChevronUpRed
            : FrameWorkImages.ic_chevron_down_red;
          return (
            <>
              <View style={styles.sectionContainer(theme, !activeSections.includes(index))}>
                {list[index].icon}
                <VFText i18nKey={content} style={styles.sectionItemTitle} />
                <Icon name={icon} type="image" style={styles.chevronIcon(theme)} />
              </View>
            </>
          );
        }}
        renderContent={(_content, index) => {
          return list[index].content;
        }}
        onChange={indexes => {
          this.setState({ activeSections: indexes });
        }}
        onSectionContainerLayout={() => {}}
      />
    );
  };
  render() {
    const {
      onConfirmPress,
      deviceDetails,
      isDeviceDetailLoading,
      selectedColorIndex,
      selectedCapacityIndex,
      onDeviceOverviewPress,
    } = this.props;

    if (isDeviceDetailLoading) {
      return null;
    }
    if (_isEmpty(deviceDetails)) {
      return null;
    }
    const colors = _get(deviceDetails, 'colors', []);
    const capacity = _get(deviceDetails, 'capacity', []);
    const selectedDeviceColor = _get(colors, selectedColorIndex, null);
    const deviceImage = _get(selectedDeviceColor, 'deviceImage', null);
    return (
      <ScrollView contentContainerStyle={styles.containerStyle}>
        <View style={styles.deviceImageContainer}>
          {deviceImage && <Icon name={deviceImage} type="image" size={340} />}
        </View>

        <DeviceUpgradeSections
          selectOption={this.selectOption}
          selectedColorIndex={selectedColorIndex}
          selectedCapacityIndex={selectedCapacityIndex}
          colorsOptions={colors}
          capacityOptions={capacity}
        />
        <TouchableWithoutFeedback onPress={onDeviceOverviewPress}>
          <View style={styles.deviceOverViewBtnContainer}>
            <VFText
              type="tertiary"
              i18nKey={'device_upgrade_device_step_device_overview'}
              style={styles.deviceOverViewTxt}
            />
            <Icon
              size={25}
              name={FrameWorkImages.ic_chevron_right_red}
              style={styles.chevronIcon(this.props.theme)}
            />
          </View>
        </TouchableWithoutFeedback>

        <VFText
          type="primary"
          style={styles.moreInfoTitle}
          i18nKey={'device_upgrade_device_step_more_information'}
        />

        {this.renderSeparator()}
        {this.renderMoreInfo()}
        <View style={styles.nextStepBtn}>
          <VFButton
            title="device_upgrade_device_step_cta_button_title"
            onPress={() => onConfirmPress(deviceDetails.collection)}
          />
        </View>
      </ScrollView>
    );
  }
}
DeviceDetails.defaultProps = {
  selectColorTypeOption: () => {},
  selectCapacityTypeOption: () => {},
  onConfirmPress: () => {},
  deviceDetails: null,
  isDeviceDetailLoading: false,
  theme: LightThemeColors,
};
DeviceDetails.propTypes = {
  onConfirmPress: PropTypes.func,
  deviceDetails: PropTypes.shape({
    colors: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired,
        deviceImage: PropTypes.shape({ uri: PropTypes.string.isRequired }).isRequired,
      }),
    ),
    capacity: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        priceMonthlyIncrease: PropTypes.shape({
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          currency: PropTypes.string.isRequired,
          period: PropTypes.string.isRequired,
        }),
      }),
    ),
    specifications: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        values: PropTypes.arrayOf(PropTypes.string.isRequired),
        extraFeatures: PropTypes.arrayOf(PropTypes.string.isRequired),
      }),
    ),
    fullSpecifications: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        values: PropTypes.array.isRequired,
      }),
    ),
    boxContent: PropTypes.arrayOf(PropTypes.string.isRequired),
    collection: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        days: PropTypes.string.isRequired,
        price: PropTypes.string.isRequired,
        icon: PropTypes.object.isRequired,
      }),
    ),
  }),
  isDeviceDetailLoading: PropTypes.bool,
  selectCapacityTypeOption: PropTypes.func,
  selectColorTypeOption: PropTypes.func,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  selectedColorIndex: PropTypes.number,
  selectedCapacityIndex: PropTypes.number,
  onDeviceOverviewPress: PropTypes.func,
  onDeviceFullSpecsPress: PropTypes.func,
  isEditMode: PropTypes.bool,
};

export default withTheme(DeviceDetails);
